import React from 'react'
import PropTypes from 'prop-types'

import { Loading } from '../../common/Loading'
import { useUpdateCall } from '../../lib/api/update'
import { useGetQuery } from '../../lib/api/get'
import { ProjectPages } from './ProjectPages'
import { ProjectEdit } from './ProjectEdit'
import { ProjectSettings } from './ProjectSettings'
import { ConfirmActivate } from './ConfirmActivate'
import { ProjectTemplate } from './ProjectTemplate'

export const Projects = ({ isLocalEnvironment, envData, authDetails, allData }) => {
  const [pages, setPages] = React.useState(false)
  const [edit, setEdit] = React.useState(false)
  const [settings, setSettings] = React.useState(false)
  const [pagesContent, setPagesContent] = React.useState(null)
  const [selectedProject, setSelectedProject] = React.useState(null)
  const [useTemplate, setUseTemplate] = React.useState(false)
  const [activateConfirm, setActivateConfirm] = React.useState(false)
  const [activateId, setActivateId] = React.useState(null)
  const updateCallMutation = useUpdateCall()

  const getProjects = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'websiteProjects',
    isDynamic: true,
    params: `&isDependency=true&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`,
    enabled: authDetails.loggedIn && envData.REACT_APP_TYPE === 'builder' ? true : false,
  })
  const getPages = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'websitePages',
    isDynamic: true,
    params: `&isDependency=true&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`,
    enabled: authDetails.loggedIn && envData.REACT_APP_TYPE === 'builder' ? true : false,
  })
  const getThemes = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'themes',
    isDynamic: true,
    params: '&isDependency=true',
    enabled: authDetails.loggedIn && envData.REACT_APP_TYPE === 'builder' ? true : false,
  })
  const getImages = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'image',
    isDynamic: true,
    enabled: authDetails.loggedIn && envData.REACT_APP_TYPE === 'builder' ? true : false,
  })
  const getNavbars = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'themeNavbars',
    isDynamic: true,
    params: '&isDependency=true',
    enabled: authDetails.loggedIn && envData.REACT_APP_TYPE === 'builder' ? true : false,
  })
  const getFooters = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'themeFooters',
    isDynamic: true,
    params: '&isDependency=true',
    enabled: authDetails.loggedIn && envData.REACT_APP_TYPE === 'builder' ? true : false,
  })
  const getBlocks = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'themeBlocks',
    isDynamic: true,
    params: '&isDependency=true',
    enabled: authDetails.loggedIn && envData.REACT_APP_TYPE === 'builder' ? true : false,
  })
  const asstImg = []
  if (getImages.data?.formData.length) {
    getImages.data?.formData?.map((i) => {
      const newImg = i.fileUrl.replace('%2F', '/')
      asstImg.push(newImg)
    })
    localStorage.setItem('builderAssets', JSON.stringify(asstImg))
  }
  if (getImages.data?.formData?.data) {
    getImages.data?.formData?.data?.map((i) => {
      const newImg = i.fileUrl.replace('%2F', '/')
      asstImg.push(newImg)
    })
    localStorage.setItem('builderAssets', JSON.stringify(asstImg))
  }

  const activateSite = (id) => {
    setActivateId(id)
    setActivateConfirm(true)
  }
  const cancelActivateSite = () => {
    setActivateId(null)
    setActivateConfirm(false)
  }
  const activateSiteConfirm = async () => {
    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'websiteProjects/activate',
      id: activateId,
      messageTitle: 'Websites',
      message: 'Website published!',
      params: `&activate=true&isDependency=true&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`,
      isDynamic: true,
    })
    setActivateId(null)
    setActivateConfirm(false)
  }

  const openPages = (content) => {
    setPages(true)
    setPagesContent(content)
  }
  const closePages = () => {
    setPages(false)
    setPagesContent(null)
  }
  const closeEdit = () => {
    setEdit(false)
    setPagesContent(null)
  }
  const openSettings = (content) => {
    setSettings(true)
    setPagesContent(content)
  }
  const closeSettings = () => {
    setSettings(false)
    setPagesContent(null)
  }

  const openSelectTemplate = (project) => {
    setSelectedProject(project)
    setUseTemplate(true)
  }

  const closeSelectTemplate = () => {
    setSelectedProject(null)
    setUseTemplate(false)
  }

  if (
    getProjects.isLoading ||
    getThemes.isLoading ||
    getImages.isLoading ||
    getNavbars.isLoading ||
    getFooters.isLoading ||
    getPages.isLoading ||
    getBlocks.isLoading
  ) {
    return (
      <div id="layout-wrapper" data-testid="appLoading">
        <Loading envData={envData} />
        <div className="trtui-vertical-overlay" />
      </div>
    )
  }

  return (
    <React.Fragment key={allData}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div
            className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between"
            style={{ padding: '1.1rem' }}
          >
            <h4 className="trtui-mb-sm-0">Projects</h4>
            <div className="trtui-page-title-right trtui-pt-4"></div>
          </div>
        </div>
      </div>
      <div className="trtui-row">
        {allData.projects?.length > 0 &&
          allData.projects
            ?.sort((a, b) => b.websiteProjectIsPublished - a.websiteProjectIsPublished)
            .map((project, projectInd) => (
              <div key={projectInd} className="trtui-col-6 trtui-project-card">
                <div className="trtui-card trtui-card-height-100">
                  <div className="trtui-card-body">
                    <div className="trtui-d-flex trtui-flex-column trtui-h-100">
                      <div className="trtui-d-flex">
                        <div className="trtui-flex-grow-1">
                          {project.websiteProjectIsPublished === 1 ||
                          project.websiteProjectIsPublished === true ? (
                            <p className="trtui-fw-100 trtui-mb-4" style={{ textAlign: 'left' }}>
                              Published
                            </p>
                          ) : (
                            <p
                              className="trtui-text-muted trtui-mb-4"
                              style={{ textAlign: 'left' }}
                            >
                              <button
                                className="trtui-btn trtui-btn-warning trtui-btn-sm"
                                onClick={() => activateSite(project.websiteProjectId)}
                              >
                                Publish
                              </button>
                            </p>
                          )}
                        </div>
                        {project.websiteProjectIsPublished !== 1 && (
                          <button
                            className="trtui-btn trtui-btn-info trtui-btn-sm trtui-btn-icon"
                            onClick={() => openSelectTemplate(project)}
                          >
                            <i className="ri-layout-3-line" />
                          </button>
                        )}
                      </div>
                      <div className="trtui-d-flex trtui-mb-2">
                        <div className="trtui-flex-shrink-0 trtui-me-3">
                          <div className="trtui-avatar-sm">
                            <span className="trtui-avatar-title trtui-bg-warning-subtle trtui-rounded trtui-p-2">
                              <i
                                className="ri-pages-line trtui-align-bottom trtui-me-1 trtui-text-primary"
                                style={{ fontSize: '1.5rem' }}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="trtui-flex-grow-1" style={{ textAlign: 'left' }}>
                          <h5 className="trtui-mb-1 trtui-fs-15">
                            <a href="#!" className="trtui-text-body">
                              {project.websiteName}
                            </a>
                          </h5>
                          <p className="trtui-text-muted trtui-text-truncate-two-lines trtui-mb-3">
                            {project.websiteProjectIsPublished === 1 ||
                            project.websiteProjectIsPublished === true
                              ? 'Website is published, published website is readonly'
                              : 'Staging site will be available only for admins for preview.'}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="trtui-card-footer trtui-bg-transparent trtui-border-top-dashed trtui-py-2">
                    {project.websiteProjectIsPublished === 0 ||
                    project.websiteProjectIsPublished !== true ? (
                      <div className="trtui-d-flex trtui-align-items-center">
                        <div className="trtui-flex-grow-1">
                          <div className="trtui-avatar-group">
                            <span
                              onClick={() => openSettings(project)}
                              className="trtui-avatar-group-item"
                              style={{ cursor: 'pointer' }}
                            >
                              <div className="trtui-avatar-xxs">
                                <i
                                  className="mdi mdi-spin mdi-cog-outline"
                                  style={{ fontSize: '1.2rem' }}
                                ></i>
                              </div>
                            </span>
                          </div>
                        </div>
                        <div className="trtui-flex-shrink-0">
                          <div className="trtui-text-muted">
                            <button
                              className="trtui-btn trtui-btn-primary trtui-btn-sm"
                              onClick={() => openPages(project)}
                            >
                              <i className="ri-pages-line trtui-align-bottom trtui-me-1" />
                              Pages
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="trtui-d-flex trtui-align-items-center">
                        <div className="trtui-flex-grow-1">
                          <div className="trtui-avatar-group">
                            <span className="trtui-avatar-group-item">
                              <div className="trtui-avatar-xxs"> </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
      </div>
      {pages && (
        <ProjectPages
          closePages={closePages}
          pagesContent={pagesContent}
          isLocalEnvironment={isLocalEnvironment}
          authDetails={authDetails}
        />
      )}
      {edit && (
        <ProjectEdit
          closeEdit={closeEdit}
          pagesContent={pagesContent}
          isLocalEnvironment={isLocalEnvironment}
        />
      )}
      {settings && (
        <ProjectSettings
          closeSettings={closeSettings}
          pagesContent={pagesContent}
          isLocalEnvironment={isLocalEnvironment}
          envData={envData}
          authDetails={authDetails}
        />
      )}
      {activateConfirm && (
        <ConfirmActivate
          activateSiteConfirm={activateSiteConfirm}
          updateCallMutation={updateCallMutation}
          cancelActivateSite={cancelActivateSite}
        />
      )}
      {useTemplate && (
        <ProjectTemplate
          closeSelectTemplate={closeSelectTemplate}
          selectedProject={selectedProject}
          data={allData.themes}
          isLocalEnvironment={isLocalEnvironment}
          envData={envData}
        />
      )}
    </React.Fragment>
  )
}

Projects.propTypes = {
  isLocalEnvironment: PropTypes.string.isRequired,
  envData: PropTypes.object.isRequired,
  authDetails: PropTypes.object.isRequired,
  allData: PropTypes.object,
}
